import { isFunction, isHTMLElement } from '@mbrtargeting/metatag-utils';
import { logger } from '../../../loader/essentials/logger.js';
import { LifecycleAction } from '../adslot-controller/adslot-lifecycle-state.js';
import { CreativeSource, CreativeSourceLoadSlotsParams } from '../adslot-controller/creative-source.js';

const log = logger.logGroup({ prefix: 'NativeBackfill' });

export class NativeBackfill implements CreativeSource {

    public async loadSlots({ adslots, done }: CreativeSourceLoadSlotsParams): Promise<void> {

        // check if backFill is present. If not, send to next demand source, otherwise fill slot.
        log.debug('calling slots: %o', [adslots.map(adslot => adslot.slotName.toUpperCase())]);
        for (const adslot of adslots) {
            try {
                const backfill = (isFunction(adslot.nativeBackfillFunction)) ? adslot.nativeBackfillFunction() : undefined;
                if (isHTMLElement(backfill)) {
                    // mark slot as filled as soon as possible
                    await adslot.lifecycle.dispatch(LifecycleAction.FILL);
                    // add instruction to remove backfill when slot is reset
                    adslot.lifecycle.onAction(LifecycleAction.RESET, async () => {
                        backfill?.parentElement?.removeChild(backfill);
                    }, { once: true });
                    // add backfill div to slot
                    adslot.adserverAnchor.appendChild(backfill);
                    log.info('%s: filled.', [adslot.slotName.toUpperCase()]);
                }
            } catch (e) {
                log.error('%s: nativeBackfillFunction error: %o', [adslot.slotName.toUpperCase(), e, adslot.nativeBackfillFunction?.toString()]);
            }
        }
        done(adslots);
    }
}
